import { llmThreadLiteSchema } from "@redotech/redo-agents-common/llm-thread-lite";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getChildThreads = {
  name: "getChildThreads" as const,
  input: z.object({ parentThreadId: zExt.objectId() }),
  output: z.object({
    data: z.array(llmThreadLiteSchema),
    totalCount: z.number(),
  }),
};
